import type { KpiCardSpec } from './card-spec';

/**
 * The Account swaps scalar, shown on the Retention & Health page's Retention
 * breakdown and the Users page's Retention pulse section. One object in two
 * catalogs, so the two pages cannot report different figures.
 */
export const ACCOUNT_SWAPS_SCALAR_CARD: KpiCardSpec = {
    title: 'Account swaps',
    source: 'churn',
    metric: 'accountSwaps',
    form: 'number',
    size: 'sm',
    description:
        'Accounts deleted and re-created the same day, a subset of Account deletions. Subtracted from the churn rate, since a swap is a delete plus a create rather than a departure.',
};
